import Medium1 from "./img/krealogi.png";
import Medium2 from "./img/levelUp.png";
import logo_html from "./img/html.png";
import logo_css from "./img/css.png";
import logo_js from "./img/javascript.png";
import logo_react from "./img/react.png";
import logo_illustrator from "./img/illustrator.png";
import logo_photoshop from "./img/photoshop.png";
import logo_premierepro from "./img/premierepro.png";
import logo_aftereffect from "./img/aftereffect.png";
import logo_figma from "./img/figma.png";
import logo_laravel from "./img/laravel.png";

export const Experiences = [
  {
    position: "Course Instructor Programming",
    institusi: "Gamelab Indonesia - Trainer Programming",
    tahun: "Jan 2023 - Present",
    desc: "Creating Modules, Review and Assesment, Teaching through webinar and offline.",
    logo: logo_html
  },
  {
    position: "UI/UX Designer",
    institusi: "Skilvul - Internship",
    tahun: "Aug 2021 - Dec 2021",
    desc: "I work as a UI/UX Designer. Internship program for 5 months, the first 3 months providing material and training to make interface designs. then the last 2 months there is a challenge partner from skilvul.",
    logo: logo_html
  },
  {
    position: "Mobile Developer",
    institusi:
      "Bangkit Academy led by Google, Tokopedia, Gojek, & Traveloka - Internship",
    tahun: "Feb 2021 - Jul 2021",
    desc: "I am enrolled in the Mobile Development learning path, Learning how to become a mobile developer from beginner to expert. Collaborating with a team to create a capstone project.",
    logo: logo_html
  },
  {
    position: "Graphic Designer",
    institusi: "Resta Pendopo KM 456 Salatiga - Internship",
    tahun: "Sep 2020 - Oct 2020",
    desc: "I work as a graphic designer. is in the marketing field, given the task to making signs in the rest area parking lot, tenant posters, and making product feeds on Instagram.",
    logo: logo_html
  },
];

export const MyMediums = [
  {
    judul: "UI & UX Case Study Krealogi CRM",
    penulis: "Muhammad Najib RB",
    tanggal: "Nov 28, 2021",
    link: "https://medium.com/@najibdani21/ui-ux-case-study-krealogi-simple-customer-relationship-management-crm-2edc99288ac8",
    gambar: Medium1,
  },
  {
    judul: "Aplikasi Edukasi 'LevelUp'",
    penulis: "Muhammad Najib RB",
    tanggal: "Oct 24, 2021",
    link: "https://medium.com/@najibdani21/aplikasi-edukasi-levelup-8933d8aedcbe",
    gambar: Medium2,
  },
];

export const MySkills = [
  {
    gambar: logo_html,
    skill: "HTML",
    persentace: 0.9,
  },
  {
    gambar: logo_css,
    skill: "CSS",
    persentace: 0.9,
  },
  {
    gambar: logo_js,
    skill: "JavaScript",
    persentace: 0.9,
  },
  {
    gambar: logo_laravel,
    skill: "Laravel",
    persentace: 0.9,
  },
  {
    gambar: logo_react,
    skill: "ReactJS",
    persentace: 0.9,
  },
  {
    gambar: logo_figma,
    skill: "Figma",
    persentace: 0.9,
  },
  {
    gambar: logo_illustrator,
    skill: "Adobe Illustrator",
    persentace: 0.9,
  },
  {
    gambar: logo_photoshop,
    skill: "Adobe Photoshop",
    persentace: 0.9,
  },
  {
    gambar: logo_premierepro,
    skill: "Adobe Premiere Pro",
    persentace: 0.9,
  },
  {
    gambar: logo_aftereffect,
    skill: "Adobe After Effect",
    persentace: 0.9,
  },
];
